import { DemoModeContext } from '../hooks/useDemoContext'

interface DemoModeProviderProps {
  isDemoMode?: boolean
  children: React.ReactNode
}

export default function DemoModeProvider({
  isDemoMode = false,
  children,
}: DemoModeProviderProps) {
  return (
    <DemoModeContext.Provider value={{ isDemoMode }}>
      {children}
    </DemoModeContext.Provider>
  )
}
